import React, { useCallback } from 'react'
import { FlatList } from 'react-native'

import { zodResolver } from '@hookform/resolvers/zod'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { Stack } from '@zet/design-system'
import { KeyBoardWrapper } from '@zet/utils'
import { useAddCustomerState } from '@zet/zet-pro-quick-journey/hooks/useAddCustomer'
import { useForm } from 'react-hook-form'

import { Button, ScreenTitle } from '../../components'
import FormController from '../../form/FormController'
import { sendAnalyticsData } from '../../utils/analyticsEvents'
import { panDetailsValidationScheme } from '../../utils/validationSchemas'
import { customerPanDetailsFormFields } from './formFields'

export const CustomerPanDetails = () => {
  const { mutate, isLoading } = useAddCustomerState()
  const { customerId } = useAddCustomerStore()

  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm({
    mode: 'onTouched',
    resolver: zodResolver(panDetailsValidationScheme),
  })

  const renderItem = useCallback(({ item }) => {
    return <FormController control={control} ocField={item} />
  }, [])

  const handleSubmit = () => {
    sendAnalyticsData({
      screen: 'SHOW_PAN_SCREEN_JFS',
      type: 'click',
    })
    const { dob, panNumber } = getValues()
    const urlParams = new URLSearchParams(window.location.search)

    const custId = urlParams.get('customerId')
    const requestBodyData = {
      dob,
      panNo: panNumber,
      customerId: custId || customerId,
      screenName: 'SHOWN_PAN_SCREEN_JFS',
    }
    mutate(requestBodyData, {
      onSuccess: (data) => {
        sendAnalyticsData({ screen: data?.action, type: 'screen' })
      },
    })
  }

  return (
    <KeyBoardWrapper
      BottomSheet={
        <Button
          disabled={!isValid || isLoading}
          onPress={handleSubmit}
          color="bg-primary-100"
          title={'Continue'}
          loading={isLoading}
          loaderText="Verifying"
        />
      }
    >
      <Stack className="bg-white px-3">
        <FlatList
          showsVerticalScrollIndicator={false}
          data={customerPanDetailsFormFields}
          ListHeaderComponent={<ScreenTitle title={'Enter Your PAN Details'} />}
          renderItem={renderItem}
        />
      </Stack>
    </KeyBoardWrapper>
  )
}
